var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useReducer } from "react";
import JetDialogModal from "../../../Jetstream/DialogModal";
import axios from "axios";
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
import useForm from "../../../Utils/useForm";
import { router } from '@inertiajs/react';
import BranchForm from "@/Pages/Branch/Partials/BranchForm";
export default function BranchEditModal(_a) {
    var team = _a.team, setEditingBranch = _a.setEditingBranch, branch = _a.branch, close = _a.close;
    var route = useRoute(Ziggy);
    var _b = useReducer(function (x) { return x + 1; }, 0), ignored = _b[0], forceUpdate = _b[1];
    var form = useForm(branch);
    function submit() {
        var fn = branch.id ? axios.put : axios.post;
        var routeName = branch.id ? 'team.branch.update' : 'team.branch.store';
        fn(route(routeName, { team: team, branch: branch }), __assign({ _modal: 1 }, form.data))
            .then(function (resp) {
            setEditingBranch(null);
            router.reload({ preserveScroll: true });
        }, function (resp) {
            var _a, _b;
            if ((_b = (_a = resp.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) {
                form.setErrors(resp.response.data.errors);
            }
            else {
                alert("An unexpected error occurred");
            }
        });
    }
    return _jsx(JetDialogModal, __assign({ isOpen: !!branch, onClose: function () { return setEditingBranch(false); } }, { children: _jsx(JetDialogModal.Content, __assign({ title: branch.id ? "Edit ".concat(branch.name) : "Create branch" }, { children: _jsx("div", __assign({ className: "mt-2" }, { children: _jsx(BranchForm, { team: team, form: form, submit: submit, close: close }) })) })) }));
}
